import { API, Auth } from 'aws-amplify';

async function getRequestHeaders (headers) {
  const currentSession = await Auth.currentSession();
  const header = {
    headers: Object.assign({}, {
      // Activate following headers when connecting to a local instance of BuildsimpleCore
      // 'x-caller-id': 'local:CognitoIdentityCredentials',
      // 'cognito-authentication-type': 'authenticated',
      // 'x-iam-user': 'local:CognitoIdentityCredentials',
      // 'x-cognito-type': 'authenticated',
      // 'x-cognito-id': 'id',
      'Bs-Token': 'Bearer ' + currentSession.idToken.jwtToken
    }, headers)
  };
  return header;
}

export async function getBsToken () {
  return (await Auth.currentSession()).idToken.jwtToken;
}

export async function questionAssistent ({ message, url, conversationId, mode }) {
  const params = await getRequestHeaders({});
  params.body = { message, url, conversationId, mode };
  return await API.post('AiAssistentAPI', '/conversation/quest', params);
}

export async function getLatestAiSession () {
  const params = await getRequestHeaders({});
  return await API.get('AiAssistentAPI', '/assistant/conversation/quest/last', params);
}
